import { Badge, type BoxProps } from "@mantine/core";
import { IconCalendarOff, IconCalendarPause, IconCalendarQuestion, IconCalendarTime } from "@tabler/icons-react";
import { useResolvedEvent } from "@vantage/core";

export const EventStatusBadge = (props: BoxProps) => {
	const { data } = useResolvedEvent();
	const status = data?.status ?? "planned";
	
	if (status === "cancelled") return (
		<Badge
			{...props}
			variant="light"
			color="red"
			leftSection={<IconCalendarOff size={18} />}
		>
			Cancelled
		</Badge>
	);

	if (status === "postponed") return (
		<Badge
			{...props}
			variant="light"
			color="yellow"
			leftSection={<IconCalendarTime size={18} />}
		>
			Postponed
		</Badge>
	);

	if (status === "suspended") return (
		<Badge
			{...props}
			variant="light"
			color="blue"
			leftSection={<IconCalendarPause size={18} />}
		>
			Suspended
		</Badge>
	);

	if (status === "uncertain") return (
		<Badge
			{...props}
			variant="light"
			color="gray"
			leftSection={<IconCalendarQuestion size={18} />}
		>
			Uncertain
		</Badge>
	);

	return null;
};